export default "__VITE_ASSET__lhaIvBHl__"